export default "__VITE_ASSET__BrN4EyCB__"